import { Action, Reducer } from "redux";
import { SupplierTypeState, SupplierTypeTypes, SupplierTypeActionTypes } from "./supplierTypeTypes";

export const INITIAL_STATE: SupplierTypeState = {
	supplierType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const supplierTypeReducer: Reducer<SupplierTypeState> = (state: SupplierTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as SupplierTypeActionTypes;
	switch (actionTypes.type) {
		case SupplierTypeTypes.GET_SUPPLIER_TYPE:
			return {
				...state,
				supplierType: { ...state.supplierType, isLoading: true },
			};
		case SupplierTypeTypes.SAVE_SUPPLIER_TYPE:
			return {
				...state,
				supplierType: {
					...state.supplierType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case SupplierTypeTypes.RESET_REDUCER_SUPPLIER_TYPE:
			return {
				...state,
				supplierType: INITIAL_STATE.supplierType,
			};
		default:
			return state;
	}
};

export default supplierTypeReducer;
